var duration = /(-?(?:\d+\.?\d*|\d*\.?\d+)(?:e[-+]?\d+)?)\s*([a-zµμ]*)/ig;
/**
 * conversion ratios
 */

parse.nanosecond = parse.ns = 1 / 1e6;
parse['µs'] = parse['μs'] = parse.us = parse.microsecond = 1 / 1e3;
parse.millisecond = parse.ms = 1;
parse.second = parse.sec = parse.s = parse.ms * 1000;
parse.minute = parse.min = parse.m = parse.s * 60;
parse.hour = parse.hr = parse.h = parse.m * 60;
parse.day = parse.d = parse.h * 24;
parse.week = parse.wk = parse.w = parse.d * 7;
parse.month = parse.b = parse.d * (365.25 / 12);
parse.year = parse.yr = parse.y = parse.d * 365.25;
/**
 * convert `str` to ms
 *
 * @param {String} str
 * @param {String} format
 * @return {Number}
 */

export default function parse() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ms';
  var result = null; // ignore commas

  str = str.replace(/(\d),(\d)/g, '$1$2');
  str.replace(duration, function (_, n, units) {
    units = parse[units] || parse[units.toLowerCase().replace(/s$/, '')];
    if (units) result = (result || 0) + parseFloat(n, 10) * units;
  });
  return result && result / parse[format];
}